import { BaseApiService } from './BaseApiService'
import { Contact, PhoneNumber, ContactLabel } from '@/types/account'

export interface ContactCreationRequest {
  firstName: string
  lastName?: string
  phoneNumbers: PhoneNumber[]
  labels?: ContactLabel[]
}

/**
 * Contacts API Service
 *
 * Handles API calls related to contact management,
 * including creating, retrieving, updating, and deleting contacts
 */
export class ContactsApiService extends BaseApiService {
  /**
   * Create a new contact
   */
  async createContact(payload: ContactCreationRequest): Promise<Contact> {
    return this.post<Contact>('/contacts', payload, {
      requiresAuth: true
    })
  }

  /**
   * Get a contact by ID
   */
  async getContact(contactId: string): Promise<Contact> {
    return this.get<Contact>(`/contacts/${contactId}`, {
      requiresAuth: true
    })
  }

  /**
   * Update an existing contact
   */
  async updateContact(contactId: string, payload: Partial<ContactCreationRequest>): Promise<Contact> {
    return this.patch<Contact>(`/contacts/${contactId}`, payload, {
      requiresAuth: true
    })
  }

  /**
   * Delete a contact
   */
  async deleteContact(contactId: string): Promise<void> {
    await this.delete<{ success: boolean }>(`/contacts/${contactId}`, {
      requiresAuth: true
    })
  }
}

// Singleton instance
export const contactsApiService = new ContactsApiService()

// Export both the class and the instance for backward compatibility
export default contactsApiService
